export const AllModalTypes = {
    MODAL: 'modal',
    SIDEBAR: 'sidebar',
};

export const MODAL_TYPES = [
    AllModalTypes.MODAL,
    AllModalTypes.SIDEBAR,
];
